import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth";
import { dashPath } from "../lib/utils-trel";
import { api } from "../lib/api";
import Logo from "../components/Logo";
import LanguageSelector from "../components/LanguageSelector";
import PreviewModeEntry from "../components/PreviewModeEntry";

export default function Login(){
  const { t } = useTranslation();
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email:"", password:"" });
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const [demoMode, setDemoMode] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get("/config")
      .then(r => { if (mounted) setDemoMode(r.data?.demo_mode !== false); })
      .catch(() => { if (mounted) setDemoMode(true); });
    return () => { mounted = false; };
  }, []);

  const submit = async () => {
    setBusy(true); setErr("");
    try {
      const u = await login(form.email, form.password);
      nav(dashPath(u.role));
    } catch(e) { setErr(t("auth.invalid_creds")); }
    setBusy(false);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/customer";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-10 bg-[#FFF8EE]">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-between">
          <Link to="/" className="inline-block"><Logo size="lg"/></Link>
          <LanguageSelector/>
        </div>
        <h1 className="font-serif text-3xl mt-8">{t("auth.welcome_back")}</h1>

        <div className="mt-6 space-y-5">
          <div><label className="text-xs uppercase tracking-widest text-[#064E3B]/70">{t("auth.email")}</label>
            <input data-testid="login-email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="kbd-input"/></div>
          <div><label className="text-xs uppercase tracking-widest text-[#064E3B]/70">{t("auth.password")}</label>
            <input data-testid="login-password" type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="kbd-input"/></div>
        </div>
        {err && <div className="text-sm text-[#FF7A45] mt-3" data-testid="login-error">{err}</div>}
        <button data-testid="login-submit" onClick={submit} disabled={busy} className="btn-coral w-full mt-7">{busy?t("auth.signing_in"):t("auth.login_btn")}</button>

        <div className="flex items-center gap-3 my-5 text-xs text-[#071A2D]/40"><div className="flex-1 h-px bg-[#071A2D]/10"/>{t("auth.or")}<div className="flex-1 h-px bg-[#071A2D]/10"/></div>
        <button data-testid="login-google" onClick={googleLogin} className="w-full border border-[#071A2D]/15 rounded-full py-3 font-medium hover:bg-[#FFF8EE]">{t("auth.continue_google")}</button>

        <div className="text-sm text-center mt-6">
          {t("auth.no_account")} <Link to="/signup" className="underline">{t("nav.signup")}</Link>
          <span className="mx-2 text-[#071A2D]/30">·</span>
          <Link to="/forgot" data-testid="login-forgot" className="underline">{t("auth.forgot")}</Link>
        </div>

        {/* Preview Mode — secondary entry point on Login. Primary entry now
            lives on /signup so new visitors can explore before deciding to
            create an account (Phase 33). */}
        {demoMode && <PreviewModeEntry variant="login" testidPrefix="demo" />}
      </div>
    </div>
  );
}
